import { safeMemo } from '../../../../common/util/safeMemo';
import { SearchResultItem } from '../../../types';
import { ProfileCard } from './ProfileCard';

interface Props {
  profiles?: SearchResultItem[];
  searchSpecialty?: string;
  searchSuburb?: string;
  isExtendedSearch?: boolean;
}

export const resultType = (isExtendedSearch: boolean | undefined) =>
  isExtendedSearch ? 'extended' : 'standard';

const inSuburb = (card: SearchResultItem, searchSuburb: string | undefined) => {
  if (card.type === 'practice') {
    return card.address?.suburb === searchSuburb;
  }

  return false;
};

export const ProfileCards = safeMemo(
  ({ profiles = [], searchSpecialty, isExtendedSearch, searchSuburb }: Props) => (
    <>
      {profiles.map((card, index) => (
        <ProfileCard
          card={card}
          index={index}
          key={`${card.type}${card.id}`}
          searchSpecialty={searchSpecialty}
          resultType={resultType(isExtendedSearch)}
          inSearchedSuburb={inSuburb(card, searchSuburb)}
        />
      ))}
    </>
  ),
);
